import intl from 'react-intl-universal'
import ArcUUID from '~/util/arc-identifiers'
import { isTagUsed } from '~/util/cleanUpTag'
import template from './template.html'
import { convert } from 'url-slug'

export default {
  restrict: 'E',
  replace: true,
  template,
  controllerAs: 'vm',
  bindings: {
    storyObj: '=',
    isRequired: '=',
    isRequiredNotify: '=',
  },
  controller: [
    '$scope',
    'tagsService',
    'storyService',
    'toastr',
    function($scope, tagsService, storyService, toastr) {
      this.intl = intl
      const tagsSettings = tagsService.getTagsSettings()

      // This line should be improved if a better error handling for failed API calls is made
      if (tagsSettings !== undefined) {
        this.allowFreeFormTags =
          tagsSettings.allowFreeFormTags !== undefined
            ? tagsSettings.allowFreeFormTags
            : true
      } else {
        this.allowFreeFormTags = false
        toastr.error(intl.get('initialLoads.settings.error'))
      }

      this.fetchStoryTags = (query) =>
        // Searches tags api by slug
        // Queries are slugified using url-slug package
        // Library configs match old behavior, while also removing accented chars
        tagsService
          .search(convert(query, { camelCase: false }))
          .then((response) => {
            return response.data.Payload.items
              .reduce((accu, item) => {
                // Dont generate auto-complete list if already exists
                for (const storyTag of this.storyObj.taxonomy.tags) {
                  if (isTagUsed(storyTag, item)) return accu
                }
                return [...accu, item]
              }, [])
              .map(({ name, description, slug }) => {
                // return tag for auto-complete.
                return {
                  text: name,
                  description,
                  slug,
                  tagId: ArcUUID.create(),
                }
              })
          })
          .catch((error) => {
            console.error('Error fetching tags', error)
            toastr.error(intl.get('ngStoryTags.error'))
            return []
          })

      this.onTagAdded = (tag) => {
        tag.description = tag.description || tag.text
        tag.slug = tag.slug || convert(tag.text, { camelCase: false })
        tag.tagId = tag.tagId === undefined ? ArcUUID.create() : tag.tagId
        // tagsService.added([tag]);
        storyService.isDirty(true)
      }

      this.tagRemoved = () => {
        storyService.isDirty(true)
      }
    },
  ],
}
